// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 1: O GÊNESIS
// ============================================================================
// Níveis 1-13 (13 níveis, 39 perguntas)

export const chapter1Translations = {
  name: "O Gênesis",
  description: "No princípio... O conhecimento vivifica o espírito",
  
  spiritualWisdom: {
    principle: "O conhecimento vivifica o espírito",
    scripture: "O meu povo foi destruído, porque lhe faltou o conhecimento (Oséias 4:6)",
    application: "Cada versículo estudado, cada verdade descoberta nutre nossa alma e fortalece nossa fé"
  },
  
  levels: {
    1: {
      name: "A Criação",
      challenge: "No princípio, criou Deus os céus e a terra...",
      easy: {
        question: "Em quantos dias Deus criou o mundo?",
        options: ["5 dias", "6 dias", "7 dias", "8 dias"],
        hint: "Pense no dia de descanso da semana",
        funFact: "💡 No sétimo dia, Deus descansou. É a origem do Sábado, dia de descanso semanal!"
      },
      medium: {
        question: "O que Deus criou no quarto dia?",
        options: ["Os animais", "O homem", "O sol, a lua e as estrelas", "As plantas"],
        hint: "Essas criações iluminam a terra e marcam o tempo",
        funFact: "🌟 Os luminares foram criados para marcar as estações e as festas religiosas!"
      },
      hard: {
        question: "O que significa que o homem foi criado 'à imagem de Deus'?",
        options: [
          "Aparência física idêntica",
          "Capacidade de criar e amar",
          "Imortalidade natural",
          "Poder divino"
        ],
        hint: "Trata-se de qualidades espirituais e intelectuais",
        funFact: "✨ A imagem de Deus em nós inclui criatividade, consciência moral e capacidade de amar!"
      }
    },
    
    2: {
      name: "A Tentação do Jardim",
      challenge: "A serpente era mais astuta que todos os animais do campo...",
      easy: {
        question: "Qual animal tentou Eva no jardim?",
        options: ["O leão", "A serpente", "A águia", "O dragão"],
        hint: "Este animal rasteja sobre o ventre",
        funFact: "🐍 A serpente representa a tentação e a astúcia em toda a Bíblia!"
      },
      medium: {
        question: "Que promessa mentirosa a serpente fez a Eva?",
        options: [
          "Sereis imortais",
          "Sereis ricos",
          "Sereis como Deus",
          "Sereis felizes"
        ],
        hint: "A serpente promete elevação ao nível divino",
        funFact: "🎭 A mentira da serpente mistura verdade e engano - técnica de tentação clássica!"
      },
      hard: {
        question: "Como esta queda ilumina nossa luta entre o bem e o mal?",
        options: [
          "O mal é mais forte",
          "O livre arbítrio implica responsabilidade",
          "Deus nos abandona",
          "A tentação é invencível"
        ],
        hint: "Trata-se de nossa capacidade de escolher e assumir as consequências",
        funFact: "🌳 A árvore do conhecimento simboliza a escolha moral que define a humanidade!"
      }
    },
    
    3: {
      name: "Caim e Abel",
      challenge: "Dois irmãos, duas ofertas, um drama eterno...",
      easy: {
        question: "Quem foi o primeiro assassino da história bíblica?",
        options: ["Abel", "Sete", "Caim", "Adão"],
        hint: "O irmão ciumento de Abel",
        funFact: "⚡ Caim torna-se o símbolo do ciúme fraternal destrutivo!"
      },
      medium: {
        question: "Por que Deus preferiu a oferta de Abel?",
        options: [
          "Quantidade maior",
          "Abel era mais bonito",
          "Oferecida com coração sincero",
          "Era carne"
        ],
        hint: "Deus olha para o coração",
        funFact: "❤️ Deus olha para o coração, não apenas para a aparência de nossas ações!"
      },
      hard: {
        question: "O que esta história nos ensina sobre o ciúme?",
        options: [
          "O ciúme é natural",
          "O ciúme não controlado leva à destruição",
          "Deus favorece alguns",
          "A competição é saudável"
        ],
        hint: "Trata-se das consequências de não controlar nossas emoções",
        funFact: "🔥 'O pecado jaz à porta' - Deus nos adverte antes da queda!"
      }
    },

    4: {
      name: "O Dilúvio de Noé",
      challenge: "E choveu sobre a terra quarenta dias e quarenta noites...",
      easy: {
        question: "Quantos dias e noites durou a chuva do dilúvio?",
        options: ["30 dias", "40 dias", "50 dias", "100 dias"],
        hint: "Um número simbólico na Bíblia",
        funFact: "☔ O número 40 simboliza a provação e a transformação na Bíblia!"
      },
      medium: {
        question: "Quantos animais limpos Noé devia levar na arca?",
        options: [
          "1 par",
          "2 pares",
          "7 pares",
          "10 pares"
        ],
        hint: "Mais que os animais impuros",
        funFact: "🦁 Os animais limpos eram destinados aos sacrifícios após o dilúvio!"
      },
      hard: {
        question: "O que a arca simboliza em nosso caminho espiritual?",
        options: [
          "A fuga dos problemas",
          "A salvação pela fé e obediência",
          "O isolamento necessário",
          "A superioridade dos crentes"
        ],
        hint: "Trata-se da salvação oferecida aos que creem",
        funFact: "🚢 A arca prefigura a salvação: um único caminho para escapar do juízo!"
      }
    },

    5: {
      name: "A Torre de Babel",
      challenge: "Edifiquemos uma torre cujo cume toque nos céus...",
      easy: {
        question: "O que Deus confundiu em Babel?",
        options: ["Os planos", "As línguas", "As ferramentas", "Os pensamentos"],
        hint: "O que permite comunicar",
        funFact: "🗣️ Babel é a origem mítica da diversidade linguística mundial!"
      },
      medium: {
        question: "Por que os homens queriam construir esta torre?",
        options: [
          "Para se proteger",
          "Para viver juntos",
          "Para fazer um nome e alcançar o céu",
          "Para honrar a Deus"
        ],
        hint: "Trata-se de orgulho e querer igualar-se a Deus",
        funFact: "🏗️ O orgulho de querer igualar-se a Deus sempre leva à confusão!"
      },
      hard: {
        question: "Como o orgulho de Babel se manifesta hoje?",
        options: [
          "Apenas na tecnologia",
          "Na vontade humana de autonomia absoluta sem Deus",
          "Nos arranha-céus",
          "Nas línguas diferentes"
        ],
        hint: "Trata-se de querer prescindir de Deus",
        funFact: "💭 Babel nos lembra que a unidade sem Deus torna-se orgulho destrutivo!"
      }
    },

    6: {
      name: "O Chamado de Abraão",
      challenge: "Sai da tua terra, da tua parentela e da casa de teu pai...",
      easy: {
        question: "Que idade tinha Abraão quando deixou seu país?",
        options: ["50 anos", "65 anos", "75 anos", "100 anos"],
        hint: "Uma idade muito avançada para recomeçar tudo",
        funFact: "🚶 Aos 75 anos, Abraão começa uma nova vida - nunca é tarde demais!"
      },
      medium: {
        question: "Qual promessa tríplice Deus fez a Abraão?",
        options: [
          "Riqueza, poder, sabedoria",
          "Terra, descendência, bênção universal",
          "Vida longa, paz, prosperidade",
          "Fé, esperança, amor"
        ],
        hint: "Uma promessa que concerne toda a humanidade",
        funFact: "🌟 A promessa a Abraão concerne toda a humanidade, não apenas ele!"
      },
      hard: {
        question: "O que o 'salto de fé' de Abraão nos ensina?",
        options: [
          "A fé cega é perigosa",
          "Seguir a Deus exige soltar nossas seguranças",
          "Deus favorece certos povos",
          "A fé garante o sucesso"
        ],
        hint: "Trata-se de confiar abandonando nossos referenciais",
        funFact: "✨ Abraão é chamado 'pai da fé' porque creu sem ver!"
      }
    },

    7: {
      name: "O Sacrifício de Isaque",
      challenge: "Toma teu filho, teu único filho, Isaque, a quem amas...",
      easy: {
        question: "Em que monte Abraão devia sacrificar Isaque?",
        options: ["Sinai", "Moriá", "Carmelo", "Sião"],
        hint: "Este monte tornar-se-á um lugar sagrado",
        funFact: "🏔️ O monte Moriá tornar-se-á o local do Templo de Jerusalém!"
      },
      medium: {
        question: "O que Deus proveu no lugar de Isaque?",
        options: [
          "Um cordeiro",
          "Um carneiro preso pelos chifres",
          "Uma cabra",
          "Um touro"
        ],
        hint: "Um animal macho adulto com chifres",
        funFact: "🐏 O carneiro substituto prefigura o sacrifício substitutivo final!"
      },
      hard: {
        question: "Como esta prova ilustra a fé absoluta?",
        options: [
          "Deus testa cruelmente",
          "A fé transcende até o amor paternal",
          "Os sacrifícios humanos agradam a Deus",
          "Abraão não amava realmente Isaque"
        ],
        hint: "Trata-se de confiar mesmo quando não entendemos",
        funFact: "💝 Deus sempre provê uma saída quando confiamos nEle!"
      }
    },

    8: {
      name: "Jacó e Esaú",
      challenge: "O mais velho servirá ao mais novo...",
      easy: {
        question: "Por que Esaú vendeu sua primogenitura?",
        options: ["Ouro", "Um prato de lentilhas", "Roupas", "Vinho"],
        hint: "Um prato para saciar sua fome",
        funFact: "🍲 Um momento de fome custou a Esaú sua bênção eterna!"
      },
      medium: {
        question: "Como Jacó enganou seu pai Isaque?",
        options: [
          "Mudando sua voz",
          "Disfarçando-se",
          "Cobrindo-se com pele de cabra",
          "Mentindo sobre seu nome"
        ],
        hint: "Para parecer-se com seu irmão peludo",
        funFact: "🎭 Isaque, cego, reconheceu o cheiro e o toque, mas não o engano!"
      },
      hard: {
        question: "O que esta história revela sobre nossas escolhas?",
        options: [
          "O engano às vezes é necessário",
          "Desejos imediatos podem nos custar nosso destino",
          "Deus aprova a astúcia",
          "O mais novo é sempre favorecido"
        ],
        hint: "Trata-se das consequências de nossas decisões impulsivas",
        funFact: "⚖️ Nossas escolhas impulsivas podem ter consequências eternas!"
      }
    },

    9: {
      name: "O Sonho de Jacó",
      challenge: "Viu uma escada apoiada na terra, cujo topo tocava o céu...",
      easy: {
        question: "O que Jacó viu em seu sonho?",
        options: [
          "Uma árvore gigante",
          "Uma escada para o céu com anjos",
          "Um templo",
          "Estrelas"
        ],
        hint: "Um meio de comunicação entre céu e terra",
        funFact: "👼 A escada de Jacó simboliza a conexão entre o Céu e a Terra!"
      },
      medium: {
        question: "O que Jacó fez com a pedra que lhe serviu de travesseiro?",
        options: [
          "Quebrou-a",
          "Enterrou-a",
          "Ergueu-a e ungiu-a com óleo",
          "Levou-a consigo"
        ],
        hint: "Fez dela um monumento sagrado",
        funFact: "🪨 Esta pedra torna-se 'Betel' - a casa de Deus!"
      },
      hard: {
        question: "Como esta visão conecta céu e terra em nossa vida?",
        options: [
          "Apenas através dos sonhos",
          "Através da oração que estabelece a ponte com o divino",
          "Através dos anjos da guarda",
          "Através dos lugares sagrados"
        ],
        hint: "Trata-se de nossa comunicação com Deus",
        funFact: "🌉 A oração é nossa escada pessoal para o Céu!"
      }
    },

    10: {
      name: "José Vendido pelos Irmãos",
      challenge: "Eis que vem o sonhador...",
      easy: {
        question: "Quantos irmãos José tinha?",
        options: ["7 irmãos", "10 irmãos", "11 irmãos", "12 irmãos"],
        hint: "Um a menos que o número de tribos de Israel",
        funFact: "👨‍👨‍👦‍👦 Os 12 filhos de Jacó se tornarão as 12 tribos de Israel!"
      },
      medium: {
        question: "Por quantas moedas de prata José foi vendido?",
        options: [
          "10 moedas",
          "20 moedas",
          "30 moedas",
          "50 moedas"
        ],
        hint: "O preço de um escravo",
        funFact: "💰 20 moedas de prata, o preço de um escravo naquela época!"
      },
      hard: {
        question: "Como o ciúme se transforma em instrumento do plano divino?",
        options: [
          "Deus aprova o ciúme",
          "O mal cometido é transformado em bem por Deus",
          "O ciúme é necessário",
          "Os irmãos estavam certos"
        ],
        hint: "Trata-se da providência divina que transforma o mal",
        funFact: "🎨 Deus transforma até nossas piores ações em obra-prima de graça!"
      }
    },

    11: {
      name: "José na Prisão",
      challenge: "O Senhor estava com José e estendeu sobre ele sua misericórdia...",
      easy: {
        question: "Que dom especial José tinha?",
        options: [
          "Profetizar",
          "Interpretar sonhos",
          "Curar enfermos",
          "Falar com animais"
        ],
        hint: "Uma capacidade relacionada aos sonhos",
        funFact: "💭 Os sonhos eram considerados mensagens divinas na antiguidade!"
      },
      medium: {
        question: "Quais servos do Faraó estavam na prisão com José?",
        options: [
          "O vizir e o escriba",
          "O copeiro e o padeiro",
          "O médico e o guarda",
          "O cozinheiro e o jardineiro"
        ],
        hint: "Aquele que servia o vinho e aquele que servia o pão",
        funFact: "🍷 O copeiro provava o vinho do rei para evitar envenenamento!"
      },
      hard: {
        question: "O que José nos ensina sobre fidelidade na adversidade?",
        options: [
          "A injustiça é aceitável",
          "A fidelidade a Deus transcende as circunstâncias",
          "A prisão muda as pessoas",
          "É preciso vingar-se"
        ],
        hint: "Trata-se de permanecer fiel mesmo nas provações",
        funFact: "⭐ Mesmo na prisão, José permaneceu íntegro e Deus o elevou!"
      }
    },

    12: {
      name: "Os Sonhos do Faraó",
      challenge: "Sete vacas gordas... sete vacas magras...",
      easy: {
        question: "Quantas vacas magras devoraram as vacas gordas?",
        options: ["5", "6", "7", "8"],
        hint: "Um número perfeito",
        funFact: "🐄 O número 7 simboliza a perfeição e a plenitude na Bíblia!"
      },
      medium: {
        question: "O que significavam os 7 anos no sonho?",
        options: [
          "7 anos de guerra depois paz",
          "7 anos de abundância depois 7 anos de fome",
          "7 anos de doença depois saúde",
          "7 anos de chuva depois seca"
        ],
        hint: "Ciclo de abundância e escassez",
        funFact: "🌾 José salvou o Egito e sua família graças a esta interpretação!"
      },
      hard: {
        question: "Como a sabedoria divina transforma as crises?",
        options: [
          "Evitando toda crise",
          "Dando previsão para se preparar",
          "Castigando os malvados",
          "Enriquecendo os crentes"
        ],
        hint: "Trata-se de preparação e antecipação",
        funFact: "💡 A sabedoria divina transforma as crises em oportunidades de salvação!"
      }
    },

    13: {
      name: "A Reconciliação dos Irmãos",
      challenge: "Eu sou José, vosso irmão, a quem vendestes...",
      easy: {
        question: "O que José colocou no saco de Benjamim?",
        options: [
          "Ouro",
          "Seu anel",
          "Sua taça de prata",
          "Uma carta"
        ],
        hint: "Um objeto pessoal precioso",
        funFact: "🏆 A taça também servia para 'ler' o futuro na água!"
      },
      medium: {
        question: "Que frase célebre José disse sobre o mal transformado?",
        options: [
          "Eu vos perdoo",
          "Vós intentastes o mal contra mim, mas Deus o converteu em bem",
          "Esqueçamos o passado",
          "A vingança é de Deus"
        ],
        hint: "Uma frase sobre a providência divina",
        funFact: "✨ Esta frase resume toda a providência divina em nossas vidas!"
      },
      hard: {
        question: "Como o perdão rompe os ciclos de vingança?",
        options: [
          "Esquecendo o mal",
          "Libertando o ofensor e o ofendido para um novo começo",
          "Castigando primeiro",
          "Mantendo as distâncias"
        ],
        hint: "Trata-se de libertação mútua",
        funFact: "🕊️ O perdão de José prefigura o perdão divino universal!"
      }
    }
  }
};

export default chapter1Translations;
